import { Drawer, DrawerContent } from '@/components/ui/Drawer/drawer';
import { cn } from '@/utils/cn';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  contentClassName?: string;
  classNamePointer?: string;
}

const BottomSheetModal = ({ classNamePointer, open, onOpenChange, children, contentClassName }: Props) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">
      <DrawerContent className="bg-main-800 border-none text-white rounded-t-2xl px-6 pb-5 pt-3">
        <div className={cn('mx-auto mb-7 h-1 w-10 shrink-0 rounded-full bg-c600', classNamePointer)} />

        <div className={cn('flex flex-col', contentClassName)}>
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default BottomSheetModal;
